import '@fontsource-variable/inter';
import './styles/index.css';
import './styles/shared-map.css';
import './styles/plans.css';
import './styles/billing.css';
import './styles/checkin.css';
import './styles/whatif-steps.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';

async function start() {
  if (import.meta.env.VITE_API_MOCK === '1') {
    const [{ installMockApi }, { mockOnly }, { default: DemoDataPicker }] = await Promise.all([
      import('./api/mock.ts'), import('./components/mockOnly.ts'), import('./components/DemoDataPicker.tsx'),
    ]);
    installMockApi();
    mockOnly.DemoDataPicker = DemoDataPicker;
  }
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void start();
